import { t } from 'i18next';

import { Confirmation, Field, Form, Visible } from 'coreOld/components';
import { ButtonType, InputType, Size } from 'coreOld/enums';
import { uomsService } from 'partsOld/services';
import { IUomForm } from 'partsOld/types';

import { uomConversionFormSchema } from './uomConversionFormSchema';

interface IProps {
  onSubmit: (reset, setError) => (data) => void;
  isAddOpen: boolean;
  closeModal: (reset) => void;
  onRemove: () => void;
  onCancelRemove: () => void;
  selectedItem?;
  removedItem?;
}

const UomConversionFormView = ({
  onSubmit,
  isAddOpen,
  closeModal,
  selectedItem,
  removedItem,
  onRemove,
  onCancelRemove,
}: IProps) => {
  const title = selectedItem ? t('labelUpdateUomConversion') : t('labelCreateUomConversion');

  return (
    <>
      <Form<IUomForm>
        title={title}
        submitBtnLabel={title}
        removeBtnLabel={t('buttonLabelRemoveUomConversion')}
        onClose={closeModal}
        isOpen={isAddOpen || Boolean(selectedItem)}
        allowRemove={true}
        onRemove={onRemove}
        onSubmit={onSubmit}
        schema={uomConversionFormSchema}
        selectedItem={selectedItem}
      >
        <Field
          name="fromUom"
          type={InputType.ASYNC_SELECT}
          label={t('labelBaseUom')}
          required={true}
          inputProps={{
            getOptions: uomsService.getManyBaseUoms,
            getValue: (opt) => opt?.name,
            getLabel: (opt) => opt?.name,
            requestPayload: {
              filters: {
                isBase: 1,
              },
            },
            isClearable: false,
            placeholder: '',
          }}
        />

        <Field
          name="toUom"
          type={InputType.TEXTFIELD}
          label={t('labelAlternateUom')}
          required={true}
          inputProps={{
            size: Size.LG,
          }}
        />

        <Field
          name="multiplier"
          type={InputType.TEXTFIELD}
          label={t('labelMultiplier')}
          required={true}
          inputProps={{
            size: Size.LG,
          }}
        />
      </Form>

      <Visible when={Boolean(removedItem)}>
        <Confirmation
          isOpen={Boolean(removedItem)}
          onConfirm={onRemove}
          onCancel={onCancelRemove}
          title={t('labelRemoveUomConversion')}
          confirmBtnLabel={t('buttonLabelRemove')}
          confirmBtnType={ButtonType.DANGER}
          message={t('messageRemoveUomConversion')}
          size={Size.MD}
        />
      </Visible>
    </>
  );
};

export default UomConversionFormView;
